import { supabase } from "@/integrations/supabase/client";

export async function checkEmailAvailability(email: string): Promise<{
  available: boolean;
  reason?: string;
}> {
  try {
    const normalizedEmail = email.toLowerCase().trim();
    
    // Call the secure database function that bypasses RLS
    const { data, error } = await supabase.rpc('check_email_availability', {
      check_email: normalizedEmail
    });

    if (error) {
      console.error("Error checking email availability:", error);
      // Fail closed - don't allow registration if check fails
      return {
        available: false,
        reason: "Unable to verify email availability. Please try again."
      };
    }

    return data as { available: boolean; reason?: string };
  } catch (error) {
    console.error("Email validation error:", error);
    // Fail closed for security
    return {
      available: false,
      reason: "Unable to verify email availability. Please try again."
    };
  }
}
